<template>
  <div>
    <div v-if="productosContratados.length < 1">
      <vs-alert color="danger" icon-pack="feather" icon="icon-info">
        <span>No hay productos contratados en este momento.</span>
      </vs-alert>
    </div>    
    
    <div v-for="(item, indexPrincipal) in productosContratados" :key="indexPrincipal" >
      
      <!-- vxCard COMBO (FIJO+MOVIL)-->

      <div v-if="item.seccion==='PRODUCTO_PRINCIPAL'">

        <vx-card v-if="item.tipoTarjeta==='COMBO'" card-border class="mb-4">
          <vs-row>
            <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
              <span class="textoOperacionComentarioDateTime"><feather-icon icon="HexagonIcon" class="mr-2 icon" />PAQUETE PRINCIPAL</span>
            </vs-col>
          </vs-row>

          <div v-for="(prodTarj, index) in item.productoTarjetas" :key="index" >   

            <vx-card v-if="prodTarj.tarjeta==='FIJO'" title="Datos Fijo" card-border class="mb-4"> 
                    
              <div class="vx-row mb-4">                    
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span>Fecha de instalación</span>
                  </div>
                  <div>
                    <flat-pickr data-vv-as="Fecha de instalación" name="fechaInstalacion" :config="configdateTimePicker" v-model="prodTarj.fechaInstalacion" />
                  </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span>Estado</span>
                  </div>                                
                  <div>                  
                    <select-val-estado v-model="prodTarj.estado" :categoria="prodTarj.tarjeta" :estadoSelected="prodTarj.estado"/>
                  </div>
                </div>            
              </div>
              <vs-divider />
              <div class="vx-row mb-4 mt-4">
                <div class="vx-col sm:w-1/3 w-full">
                  Fijo
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`sinFijo_${prodTarj.id}`" vs-value="sinFijo">SIN FIJO</vs-radio>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`alta_${prodTarj.id}`" vs-value="alta">ALTA</vs-radio>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`portabilidad_${prodTarj.id}`" vs-value="portabilidad">PORTABILIDAD</vs-radio>
                </div>              
              </div>                
              <div v-if="prodTarj.altaPortabilidad == 'portabilidad'" class="vx-row mb-4">         
                <div class="vx-col sm:w-1/3 w-full">
                  <div>
                    <span>Fecha portabilidad</span>
                  </div>
                  <div>
                    <flat-pickr data-vv-as="PORTABILIDAD" name="fechaPortabilidad" :config="configdateTimePicker" v-model="prodTarj.fechaPortabilidad" />
                  </div>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <div>
                    <span class="campoObligatorio">Teléfono fijo *</span>
                  </div>
                  <div>
                    <vs-input class="w-full" data-vv-as="TELÉFONO FIJO" :name="`telefonoPortabilidadFijo_${prodTarj.id}`" v-validate="{required: true,regex: /^\+?([0-9]+)$/, min: 9 }" v-model="prodTarj.telefonoPortabilidad" 
                      @input="v => { prodTarj.telefonoPortabilidad = v.toUpperCase()}" />
                    <span class="text-danger text-sm"  v-show="errors.has(`telefonoPortabilidadFijo_${prodTarj.id}`)">{{ errors.first(`telefonoPortabilidadFijo_${prodTarj.id}`) }}</span>            
                  </div>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <div>
                    <span class="campoObligatorio">Operador donante *</span>
                  </div>
                  <div>
                    <vs-input class="w-full" data-vv-as="OPERADOR DONANTE" :name="`operadorDonante_${prodTarj.id}`" v-validate="{required: true}" v-model="prodTarj.operadorDonante" 
                        @input="v => { prodTarj.operadorDonante = v.toUpperCase()}" />
                    <span class="text-danger text-sm"  v-show="errors.has(`operadorDonante_${prodTarj.id}`)">{{ errors.first(`operadorDonante_${prodTarj.id}`) }}</span> 
                  </div>
                </div>
              </div>          
              <vs-divider />          
              <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full">
                  ¿El titular del fijo es el mismo que el cliente?
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualFijoCliente_${prodTarj.id}`" vs-value="S">SI</vs-radio>
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualFijoCliente_${prodTarj.id}`" vs-value="N">NO</vs-radio>
                </div>              
              </div>
              <div v-if="prodTarj.titularIgualCliente === 'N'">
                <div class="vx-row mb-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">DNI/CIF *</span>                  
                    </div>
                    <div>
                      <vx-input-group>
                        <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniTitular" v-model="prodTarj.persona.dni"
                          @input="v => { prodTarj.persona.dni = v.toUpperCase()}"/>
                        <template slot="append">
                          <div class="append-text btn-addon">
                            <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona(prodTarj.persona, index, indexPrincipal)" />
                          </div>
                        </template>
                      </vx-input-group>
                      <span class="text-danger text-sm" v-show="errors.has('dniTitular')">{{ errors.first('dniTitular') }}</span>
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">Nombre o razón social *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="NOMBRE" name="nombreTitular" v-validate="{required: true}" v-model="prodTarj.persona.nombre"
                        :disabled="titularDisabled" @input="v => { prodTarj.persona.nombre = v.toUpperCase()}"/>
                      <span class="text-danger text-sm"  v-show="errors.has('nombreTitular')">{{ errors.first('nombreTitular') }}</span> 
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span>Apellidos</span>
                    </div>
                    <div>
                      <vs-input class="w-full" name="apellidos" v-model="prodTarj.persona.apellidos"
                        :disabled="titularDisabled" @input="v => { prodTarj.persona.apellidos = v.toUpperCase()}"/>
                    </div>
                  </div>
                </div>
              </div>          
              <vs-divider />          
              <div class="vx-row mb-2 mt-2">            
                <div class="vx-col w-full">
                  <vs-collapse>
                    <vs-collapse-item>
                      <div slot="header">
                        Comentario
                      </div>
                      <div class="vx-col w-full">
                        <vs-textarea v-model="prodTarj.comentarios" @input="v => { prodTarj.comentarios = v.toUpperCase()}"/>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" :disabled="habilitarGuardarFijo(prodTarj)" @click="guardarProducto(prodTarj)">Guardar</vs-button>            
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
                  </div>
                </div>
              </div>        
            </vx-card>

            <vx-card v-if="prodTarj.tarjeta==='MOVIL'" title="Datos Movil" card-border class="mb-4">              
              <div class="vx-row mb-4 mt-4">
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span>Estado</span>
                  </div>
                  <div>
                    <select-val-estado v-model="prodTarj.estado" :categoria="prodTarj.tarjeta" :estadoSelected="prodTarj.estado"/>
                  </div>
                </div>
              </div>
              <vs-divider />
              <div class="vx-row mb-4 mt-4">
                <div class="vx-col sm:w-1/3 w-full">
                  Móvil
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`movilAlta_${prodTarj.id}`" vs-value="alta">ALTA</vs-radio>
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`movilAlta_${prodTarj.id}`" vs-value="portabilidad">PORTABILIDAD</vs-radio>
                </div>    
              </div>
              <div v-if="prodTarj.altaPortabilidad == 'portabilidad'">
                <div class="vx-row mb-4">         
                  <div class="vx-col sm:w-1/3 w-full">
                    <div>
                      <span>Fecha de portabilidad</span>
                    </div>
                    <div>
                      <flat-pickr data-vv-as="PORTABILIDAD" :name="`fechaPortabilidad_${prodTarj.id}`" :config="configdateTimePicker" v-model="prodTarj.fechaPortabilidad" />
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <div>
                      <span class="campoObligatorio">Teléfono portabilidad *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="TELÉFONO PORTABILIDAD" :name="`telefonoPortabilidad_${prodTarj.id}`" v-validate="{required: true, regex: /^\+?([0-9]+)$/, min: 9 }" v-model="prodTarj.telefonoPortabilidad" 
                        @input="v => { prodTarj.telefonoPortabilidad = v.toUpperCase()}" />
                      <span class="text-danger text-sm"  v-show="errors.has(`telefonoPortabilidad_${prodTarj.id}`)">{{ errors.first(`telefonoPortabilidad_${prodTarj.id}`) }}</span>            
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <div>
                      <span class="campoObligatorio">Operador donante *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="OPERADOR DONANTE" :name="`operadorDonante_${prodTarj.id}`" v-validate="{required: true}"  v-model="prodTarj.operadorDonante" 
                          @input="v => { prodTarj.operadorDonante = v.toUpperCase()}" />
                      <span class="text-danger text-sm"  v-show="errors.has(`operadorDonante_${prodTarj.id}`)">{{ errors.first(`operadorDonante_${prodTarj.id}`) }}</span> 
                    </div>
                  </div>  
                </div>         
                <div class="vx-row mb-4 mt-4">
                  <div class="vx-col sm:w-1/3 w-full">                 
                      Terminal y precio
                  </div>
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.terminal" :vs-name="`terminal_${prodTarj.id}`" vs-value="S">SI</vs-radio>
                  </div>              
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.terminal" :vs-name="`terminal_${prodTarj.id}`" vs-value="N">NO</vs-radio>
                  </div>                                                      
                  <div v-if="prodTarj.terminal === 'S'" class="vx-col w-full">
                    <vs-input class="w-full" vs-name="modeloTerminal" v-model="prodTarj.modeloTerminal" 
                      @input="v => { prodTarj.modeloTerminal = v.toUpperCase()}" />            
                  </div>
                </div>
                <div class="vx-row mb-4 mt-4">
                  <div class="vx-col sm:w-1/3 w-full">
                    Prepago
                  </div>
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.prepago" :vs-name="`prepago_${prodTarj.id}`" vs-value="S">SI</vs-radio>
                  </div>
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.prepago" :vs-name="`prepago_${prodTarj.id}`" vs-value="N">NO</vs-radio>
                  </div> 
                </div>  
                <div v-if="prodTarj.prepago === 'S'" class="vx-row mb-4">                        
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">ICC *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="ICC" :name="`iccc_${prodTarj.id}`" v-validate="{required: true}" v-model="prodTarj.iccc" 
                        @input="v => { prodTarj.iccc = v.toUpperCase()}" /> 
                      <span class="text-danger text-sm"  v-show="errors.has(`iccc_${prodTarj.id}`)">{{ errors.first(`iccc_${prodTarj.id}`) }}</span>           
                    </div>
                  </div>
                </div>              
              </div>   
              <vs-divider />               
              <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full">
                  ¿El titular del móvil es el mismo que el cliente?
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualClientenMovil_${prodTarj.id}`" vs-value="S">SI</vs-radio>
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualClienteMovil_${prodTarj.id}`" vs-value="N">NO</vs-radio>
                </div>              
              </div>          
              <div v-if="prodTarj.titularIgualCliente === 'N'">
                <div class="vx-row mb-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">DNI/CIF *</span>
                    </div>
                    <div>
                      <vx-input-group>
                        <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniTitular" v-model="prodTarj.persona.dni"
                          @input="v => { prodTarj.persona.dni = v.toUpperCase()}"/>
                        <template slot="append">
                          <div class="append-text btn-addon">
                            <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona(prodTarj.persona, index, indexPrincipal)" />
                          </div>
                        </template>
                      </vx-input-group>
                      <span class="text-danger text-sm"  v-show="errors.has('dniTitular')">{{ errors.first('dniTitular') }}</span>
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">Nombre o razón social *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="NOMBRE" name="nombreTitular" v-validate="{required: true}" v-model="prodTarj.persona.nombre"
                        :disabled="titularDisabled" @input="v => { prodTarj.persona.nombre = v.toUpperCase()}"/>
                      <span class="text-danger text-sm"  v-show="errors.has('nombreTitular')">{{ errors.first('nombreTitular') }}</span> 
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span>Apellidos</span>
                    </div>
                    <div>
                      <vs-input class="w-full" name="apellidos" v-model="prodTarj.persona.apellidos"
                        :disabled="titularDisabled" @input="v => { prodTarj.persona.apellidos = v.toUpperCase()}"/>
                    </div>
                  </div>
                </div>
              </div>
              <vs-divider />
              <div class="vx-row mb-2">            
                <div class="vx-col w-full">
                  <vs-collapse>
                    <vs-collapse-item>
                      <div slot="header">
                        Comentario
                      </div>
                      <div class="vx-col w-full">
                        <vs-textarea v-model="prodTarj.comentarios" @input="v => { prodTarj.comentarios = v.toUpperCase()}"/>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </div> 
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" :disabled="habilitarGuardarMovil(prodTarj)" @click="guardarProducto(prodTarj)">Guardar</vs-button>            
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
                  </div>
                </div>
              </div>
            </vx-card>
            
          </div>

        </vx-card>      

        <!-- vxCard COMBO_TV (COMBO+MOVIL+TV)-->

        <vx-card v-if="item.tipoTarjeta==='COMBO_TV'" card-border class="mb-4">
          <vs-row>
            <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
              <span class="textoOperacionComentarioDateTime"><feather-icon icon="HexagonIcon" class="mr-2 icon" />PAQUETE PRINCIPAL</span>
            </vs-col>
          </vs-row>

          <div v-for="(prodTarj, index) in item.productoTarjetas" :key="prodTarj.id" >   

            <vx-card v-if="prodTarj.tarjeta==='FIJO'" title="Datos Fijo" card-border class="mb-4">        
              <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span>Fecha de instalación</span>
                  </div>
                  <div>
                    <flat-pickr data-vv-as="Fecha de instalación" name="fechaInstalacion" :config="configdateTimePicker" v-model="prodTarj.fechaInstalacion" />
                  </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span>Estado</span>
                  </div>
                  <div>
                    <select-val-estado v-model="prodTarj.estado" :categoria="prodTarj.tarjeta" :estadoSelected="prodTarj.estado"/>
                  </div>
                </div>            
              </div>
              <vs-divider />
              <div class="vx-row mb-4 mt-4">
                <div class="vx-col sm:w-1/3 w-full">
                  Fijo
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`sinFijo_${prodTarj.id}`" vs-value="sinFijo">SIN FIJO</vs-radio>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`alta_${prodTarj.id}`" vs-value="alta">ALTA</vs-radio>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`portabilidad_${prodTarj.id}`" vs-value="portabilidad">PORTABILIDAD</vs-radio>
                </div>              
              </div>                
              <div v-if="prodTarj.altaPortabilidad == 'portabilidad'" class="vx-row mb-4">         
                <div class="vx-col sm:w-1/3 w-full">
                  <div>
                    <span>Fecha portabilidad</span>
                  </div>
                  <div>
                    <flat-pickr data-vv-as="PORTABILIDAD" name="fechaPortabilidad" :config="configdateTimePicker" v-model="prodTarj.fechaPortabilidad" />
                  </div>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <div>
                    <span class="campoObligatorio">Teléfono fijo *</span>
                  </div>
                  <div>
                    <vs-input class="w-full" data-vv-as="TELÉFONO FIJO" :name="`telefonoPortabilidadFijo_${prodTarj.id}`" v-validate="{regex: /^\+?([0-9]+)$/, min: 9 }" v-model="prodTarj.telefonoPortabilidad" 
                      @input="v => { prodTarj.telefonoPortabilidad = v.toUpperCase()}" />
                    <span class="text-danger text-sm"  v-show="errors.has(`telefonoPortabilidadFijo_${prodTarj.id}`)">{{ errors.first(`telefonoPortabilidadFijo_${prodTarj.id}`) }}</span>            
                  </div>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <div>
                    <span class="campoObligatorio">Operador donante *</span>
                  </div>
                  <div>
                    <vs-input class="w-full" data-vv-as="OPERADOR DONANTE" :name="`operadorDonante_${prodTarj.id}`" v-validate="{required: true}" v-model="prodTarj.operadorDonante" 
                        @input="v => { prodTarj.operadorDonante = v.toUpperCase()}" />
                    <span class="text-danger text-sm"  v-show="errors.has(`operadorDonante_${prodTarj.id}`)">{{ errors.first(`operadorDonante_${prodTarj.id}`) }}</span> 
                  </div>
                </div> 
              </div>         
              <vs-divider />          
              <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full">
                  ¿El titular del fijo es el mismo que el cliente?
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualFijoCliente_${prodTarj.id}`" vs-value="S">SI</vs-radio>
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualFijoCliente_${prodTarj.id}`" vs-value="N">NO</vs-radio>
                </div>              
              </div>
              <div v-if="prodTarj.titularIgualCliente === 'N'">
                <div class="vx-row mb-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span>DNI/CIF</span>                  
                    </div>
                    <div>
                      <vx-input-group>
                        <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniTitular" v-model="prodTarj.persona.dni"
                          @input="v => { prodTarj.persona.dni = v.toUpperCase()}"/>
                        <template slot="append">
                          <div class="append-text btn-addon">
                            <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona(prodTarj.persona, index, indexPrincipal)" />
                          </div>
                        </template>
                      </vx-input-group>
                      <span class="text-danger text-sm" v-show="errors.has('dniTitular')">{{ errors.first('dniTitular') }}</span>
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span>Nombre o razón social</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="NOMBRE" name="nombreTitular" v-validate="{required: true}" v-model="prodTarj.persona.nombre"
                        :disabled="titularDisabled" @input="v => { prodTarj.persona.nombre = v.toUpperCase()}"/>
                      <span class="text-danger text-sm"  v-show="errors.has('nombreTitular')">{{ errors.first('nombreTitular') }}</span> 
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span>Apellidos</span>
                    </div>
                    <div>
                      <vs-input class="w-full" name="apellidos" v-model="prodTarj.persona.apellidos"
                        :disabled="titularDisabled" @input="v => { prodTarj.persona.apellidos = v.toUpperCase()}"/>
                    </div>
                  </div>
                </div>
              </div>          
              <vs-divider />          
              <div class="vx-row mb-2 mt-2">            
                <div class="vx-col w-full">
                  <vs-collapse>
                    <vs-collapse-item>
                      <div slot="header">
                        Comentario
                      </div>
                      <div class="vx-col w-full">
                        <vs-textarea v-model="prodTarj.comentarios" @input="v => { prodTarj.comentarios = v.toUpperCase()}"/>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" :disabled="habilitarGuardarFijo(prodTarj)" @click="guardarProducto(prodTarj)">Guardar</vs-button>            
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
                  </div>
                </div>
              </div>        
            </vx-card>

            <vx-card v-if="prodTarj.tarjeta==='MOVIL'" title="Datos Móvil" card-border class="mb-4">
              <div class="vx-row mb-4 mt-4">
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span>Estado</span>
                  </div>
                  <div>
                    <select-val-estado v-model="prodTarj.estado" :categoria="prodTarj.tarjeta" :estadoSelected="prodTarj.estado"/>
                  </div>
                </div>
              </div>
              <vs-divider />
              <div class="vx-row mb-4 mt-4">
                <div class="vx-col sm:w-1/3 w-full">
                  Móvil
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`movilAlta_${prodTarj.id}`" vs-value="alta">ALTA</vs-radio>
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`movilAlta_${prodTarj.id}`" vs-value="portabilidad">PORTABILIDAD</vs-radio>
                </div>    
              </div>
              <div v-if="prodTarj.altaPortabilidad == 'portabilidad'">
                <div class="vx-row mb-4">         
                  <div class="vx-col sm:w-1/3 w-full">
                    <div>
                      <span>Fecha de portabilidad</span>
                    </div>
                    <div>
                      <flat-pickr data-vv-as="PORTABILIDAD" :name="`fechaPortabilidad_${prodTarj.id}`" :config="configdateTimePicker" v-model="prodTarj.fechaPortabilidad" />
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <div>
                      <span class="campoObligatorio">Teléfono portabilidad *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="TELÉFONO PORTABILIDAD" :name="`telefonoPortabilidad_${prodTarj.id}`" v-validate="{required: true, regex: /^\+?([0-9]+)$/, min: 9 }" v-model="prodTarj.telefonoPortabilidad" 
                        @input="v => { prodTarj.telefonoPortabilidad = v.toUpperCase()}" />
                      <span class="text-danger text-sm"  v-show="errors.has(`telefonoPortabilidad_${prodTarj.id}`)">{{ errors.first(`telefonoPortabilidad_${prodTarj.id}`) }}</span>            
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <div>
                      <span class="campoObligatorio">Operador donante *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="OPERADOR DONANTE" :name="`operadorDonante_${prodTarj.id}`" v-validate="{required: true}" v-model="prodTarj.operadorDonante" 
                          @input="v => { prodTarj.operadorDonante = v.toUpperCase()}" />
                      <span class="text-danger text-sm"  v-show="errors.has(`operadorDonante_${prodTarj.id}`)">{{ errors.first(`operadorDonante_${prodTarj.id}`) }}</span> 
                    </div>
                  </div>
                </div>            
                <div class="vx-row mb-4 mt-4">
                  <div class="vx-col sm:w-1/3 w-full">                 
                      Terminal y precio
                  </div>
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.terminal" :vs-name="`terminal_${prodTarj.id}`" vs-value="S">SI</vs-radio>
                  </div>              
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.terminal" :vs-name="`terminal_${prodTarj.id}`" vs-value="N">NO</vs-radio>
                  </div>                                                      
                  <div v-if="prodTarj.terminal === 'S'" class="vx-col w-full">
                    <vs-input class="w-full" vs-name="modeloTerminal" v-model="prodTarj.modeloTerminal" 
                      @input="v => { prodTarj.modeloTerminal = v.toUpperCase()}" />            
                  </div>
                </div>
                <div class="vx-row mb-4 mt-4">
                  <div class="vx-col sm:w-1/3 w-full">
                    Prepago
                  </div>
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.prepago" :vs-name="`prepago_${prodTarj.id}`" vs-value="S">SI</vs-radio>
                  </div>
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.prepago" :vs-name="`prepago_${prodTarj.id}`" vs-value="N">NO</vs-radio>
                  </div> 
                </div>  
                <div v-if="prodTarj.prepago === 'S'" class="vx-row mb-4">                        
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">ICC *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="ICC" :name="`iccc_${prodTarj.id}`" v-validate="{required: true}" v-model="prodTarj.iccc" 
                        @input="v => { prodTarj.iccc = v.toUpperCase()}" /> 
                      <span class="text-danger text-sm"  v-show="errors.has(`iccc_${prodTarj.id}`)">{{ errors.first(`iccc_${prodTarj.id}`) }}</span>           
                    </div>
                  </div>
                </div>              
              </div>   
              <vs-divider />               
              <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full">
                  ¿El titular del móvil es el mismo que el cliente?
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualClientenMovil_${prodTarj.id}`" vs-value="S">SI</vs-radio>
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualClienteMovil_${prodTarj.id}`" vs-value="N">NO</vs-radio>
                </div>              
              </div>          
              <div v-if="prodTarj.titularIgualCliente === 'N'">
                <div class="vx-row mb-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">DNI/CIF *</span>
                    </div>
                    <div>
                      <vx-input-group>
                        <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniTitular" v-model="prodTarj.persona.dni"
                          @input="v => { prodTarj.persona.dni = v.toUpperCase()}"/>
                        <template slot="append">
                          <div class="append-text btn-addon">
                            <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona(prodTarj.persona, index, indexPrincipal)" />
                          </div>
                        </template>
                      </vx-input-group>
                      <span class="text-danger text-sm"  v-show="errors.has('dniTitular')">{{ errors.first('dniTitular') }}</span>
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">Nombre o razón social *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="NOMBRE" name="nombreTitular" v-validate="{required: true}" v-model="prodTarj.persona.nombre"
                        :disabled="titularDisabled" @input="v => { prodTarj.persona.nombre = v.toUpperCase()}"/>
                      <span class="text-danger text-sm"  v-show="errors.has('nombreTitular')">{{ errors.first('nombreTitular') }}</span> 
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span>Apellidos</span>
                    </div>
                    <div>
                      <vs-input class="w-full" name="apellidos" v-model="prodTarj.persona.apellidos"
                        :disabled="titularDisabled" @input="v => { prodTarj.persona.apellidos = v.toUpperCase()}"/>
                    </div>
                  </div>
                </div>
              </div>
              <vs-divider />
              <div class="vx-row mb-2">            
                <div class="vx-col w-full">
                  <vs-collapse>
                    <vs-collapse-item>
                      <div slot="header">
                        Comentario
                      </div>
                      <div class="vx-col w-full">
                        <vs-textarea v-model="prodTarj.comentarios" @input="v => { prodTarj.comentarios = v.toUpperCase()}"/>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </div> 
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" :disabled="habilitarGuardarMovil(prodTarj)" @click="guardarProducto(prodTarj)">Guardar</vs-button>            
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
                  </div>
                </div>
              </div>
            </vx-card>

            <vx-card v-if="prodTarj.tarjeta==='TV'" title="Datos Tv" card-border class="mb-4">
              <div class="vx-row mb-2 mt-2">            
                <div class="vx-col w-full">
                  <vs-collapse>
                    <vs-collapse-item>
                      <div slot="header">
                        Comentario
                      </div>
                      <div class="vx-col w-full">
                        <vs-textarea v-model="prodTarj.comentarios" @input="v => { prodTarj.comentarios = v.toUpperCase()}"/>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" @click="guardarProducto(prodTarj)">Guardar</vs-button>            
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
                  </div>
                </div>
              </div>
            </vx-card>
            
          </div>

        </vx-card>  

        <!-- vxCard FIJO (mesma tarxeta para FIBRA e FIJO+FIBRA)-->

        <vx-card v-if="item.tipoTarjeta==='FIJO'" card-border class="mb-4"> 
          <vs-row>
            <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
              <span class="textoOperacionComentarioDateTime"><feather-icon icon="HexagonIcon" class="mr-2 icon" />PAQUETE PRINCIPAL</span>
            </vs-col>
          </vs-row>

          <div v-for="(prodTarj, index) in item.productoTarjetas" :key="index" >

            <div class="vx-row mb-4">                    
              <div class="vx-col sm:w-1/2 w-full">
                <div>
                  <span>Fecha de instalación</span>
                </div>
                <div>
                  <flat-pickr data-vv-as="Fecha de instalación" name="fechaInstalacion" :config="configdateTimePicker" v-model="prodTarj.fechaInstalacion" />
                </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <div>
                  <span>Estado</span>
                </div>
                <div>
                  <select-val-estado v-model="prodTarj.estado" :categoria="prodTarj.tarjeta" :estadoSelected="prodTarj.estado"/>
                </div>
              </div>            
            </div>
            <vs-divider />
            <div class="vx-row mb-4 mt-4">
              <div class="vx-col sm:w-1/3 w-full">
                Fijo
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`sinFijo_${indexPrincipal}`" vs-value="sinFijo">SIN FIJO</vs-radio>
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`alta_${indexPrincipal}`" vs-value="alta">ALTA</vs-radio>
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`portabilidad_${indexPrincipal}`" vs-value="portabilidad">PORTABILIDAD</vs-radio>
              </div>              
            </div>                
            <div v-if="prodTarj.altaPortabilidad == 'portabilidad'" class="vx-row mb-4">         
              <div class="vx-col sm:w-1/3 w-full">
                <div>
                  <span>Fecha portabilidad</span>
                </div>
                <div>
                  <flat-pickr data-vv-as="PORTABILIDAD" name="fechaPortabilidad" :config="configdateTimePicker" v-model="prodTarj.fechaPortabilidad" />
                </div>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div>
                  <span class="campoObligatorio">Teléfono fijo *</span>
                </div>
                <div>
                  <vs-input class="w-full" data-vv-as="TELÉFONO FIJO" :name="`telefonoPortabilidadFijo_${prodTarj.id}`" v-validate="{regex: /^\+?([0-9]+)$/, min: 9 }" v-model="prodTarj.telefonoPortabilidad" 
                    @input="v => { prodTarj.telefonoPortabilidad = v.toUpperCase()}" />
                  <span class="text-danger text-sm"  v-show="errors.has(`telefonoPortabilidadFijo_${prodTarj.id}`)">{{ errors.first(`telefonoPortabilidadFijo_${prodTarj.id}`) }}</span>            
                </div>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                  <div>
                    <span class="campoObligatorio">Operador donante *</span>
                  </div>
                  <div>
                    <vs-input class="w-full" data-vv-as="OPERADOR DONANTE" :name="`operadorDonante_${prodTarj.id}`" v-validate="{required: true}" v-model="prodTarj.operadorDonante" 
                        @input="v => { prodTarj.operadorDonante = v.toUpperCase()}" />
                    <span class="text-danger text-sm"  v-show="errors.has(`operadorDonante_${prodTarj.id}`)">{{ errors.first(`operadorDonante_${prodTarj.id}`) }}</span> 
                  </div>
                </div>
            </div>          
            <vs-divider />          
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                ¿El titular del fijo es el mismo que el cliente?
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualFijoCliente_${indexPrincipal}`" vs-value="S">SI</vs-radio>
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualFijoCliente_${indexPrincipal}`" vs-value="N">NO</vs-radio>
              </div>              
            </div>
            <div v-if="prodTarj.titularIgualCliente === 'N'">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span class="campoObligatorio">DNI/CIF *</span>                  
                  </div>
                  <div>
                    <vx-input-group>
                      <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniTitular" v-model="prodTarj.persona.dni"
                        @input="v => { prodTarj.persona.dni = v.toUpperCase()}"/>
                      <template slot="append">
                        <div class="append-text btn-addon">
                          <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona(prodTarj.persona, index, indexPrincipal)" />
                        </div>
                      </template>
                    </vx-input-group>
                    <span class="text-danger text-sm"  v-show="errors.has('dniTitular')">{{ errors.first('dniTitular') }}</span>
                  </div>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span class="campoObligatorio">Nombre o razón social *</span>
                  </div>
                  <div>
                    <vs-input class="w-full" data-vv-as="NOMBRE" name="nombreTitular" v-validate="{required: true}" v-model="prodTarj.persona.nombre"
                      :disabled="titularDisabled" @input="v => { prodTarj.persona.nombre = v.toUpperCase()}"/>
                    <span class="text-danger text-sm"  v-show="errors.has('nombreTitular')">{{ errors.first('nombreTitular') }}</span> 
                  </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span>Apellidos</span>
                  </div>
                  <div>
                    <vs-input class="w-full" name="apellidos" v-model="prodTarj.persona.apellidos"
                      :disabled="titularDisabled" @input="v => { prodTarj.persona.apellidos = v.toUpperCase()}"/>
                  </div>
                </div>
              </div>
            </div>          
            <vs-divider />          
            <div class="vx-row mb-2 mt-2">            
              <div class="vx-col w-full">
                <vs-collapse>
                  <vs-collapse-item>
                    <div slot="header">
                      Comentario
                    </div>
                    <div class="vx-col w-full">
                      <vs-textarea v-model="prodTarj.comentarios" @input="v => { prodTarj.comentarios = v.toUpperCase()}"/>
                    </div>
                  </vs-collapse-item>
                </vs-collapse>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <vs-button class="ml-auto mt-2" :disabled="habilitarGuardarFijo(prodTarj)" @click="guardarProducto(prodTarj)">Guardar</vs-button>            
                  <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
                </div>
              </div>
            </div>       

          </div>

        </vx-card>

        <!-- vxCard MOVIL PRINCIPAL -->
        
        <vx-card v-if="item.tipoTarjeta==='MOVIL'" card-border class="mb-4">           

          <vs-row>
            <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
              <span class="textoOperacionComentarioDateTime"><feather-icon icon="SmartphoneIcon" class="mr-2 icon" />MOVIL PRINCIPAL</span>
            </vs-col>
          </vs-row>

            <div v-for="(prodTarj, index) in item.productoTarjetas" :key="index" >

              <div class="vx-row mb-4 mt-4">
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span>Estado</span>
                  </div>
                  <div>
                    <select-val-estado v-model="prodTarj.estado" :categoria="prodTarj.tarjeta" :estadoSelected="prodTarj.estado"/>
                  </div>
                </div>
              </div>
              <vs-divider />
              <div class="vx-row mb-4 mt-4">
                <div class="vx-col sm:w-1/3 w-full">
                  Móvil
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`movilAlta_${indexPrincipal}`" vs-value="alta">ALTA</vs-radio>
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`movilAlta_${indexPrincipal}`" vs-value="portabilidad">PORTABILIDAD</vs-radio>
                </div>    
              </div>
              <div v-if="prodTarj.altaPortabilidad == 'portabilidad'">
                <div class="vx-row mb-4">         
                  <div class="vx-col sm:w-1/3 w-full">
                    <div>
                      <span>Fecha de portabilidad</span>
                    </div>
                    <div>
                      <flat-pickr data-vv-as="PORTABILIDAD" :name="`fechaPortabilidad_${indexPrincipal}`" :config="configdateTimePicker" v-model="prodTarj.fechaPortabilidad" />
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <div>
                      <span class="campoObligatorio">Teléfono portabilidad *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="TELÉFONO PORTABILIDAD" :name="`telefonoPortabilidad_${prodTarj.id}`" v-validate="{required: true, regex: /^\+?([0-9]+)$/, min: 9 }" v-model="prodTarj.telefonoPortabilidad" 
                        @input="v => { prodTarj.telefonoPortabilidad = v.toUpperCase()}" />
                      <span class="text-danger text-sm"  v-show="errors.has(`telefonoPortabilidad_${prodTarj.id}`)">{{ errors.first(`telefonoPortabilidad_${prodTarj.id}`) }}</span>            
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <div>
                      <span class="campoObligatorio">Operador donante *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="OPERADOR DONANTE" :name="`operadorDonante_${prodTarj.id}`" v-validate="{required: true}" v-model="prodTarj.operadorDonante" 
                          @input="v => { prodTarj.operadorDonante = v.toUpperCase()}" />
                      <span class="text-danger text-sm"  v-show="errors.has(`operadorDonante_${prodTarj.id}`)">{{ errors.first(`operadorDonante_${prodTarj.id}`) }}</span> 
                    </div>
                  </div>
                </div>            
                <div class="vx-row mb-4 mt-4">
                  <div class="vx-col sm:w-1/3 w-full">                 
                      Terminal y precio
                  </div>
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.terminal" :vs-name="`terminal_${indexPrincipal}`" vs-value="S">SI</vs-radio>
                  </div>              
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.terminal" :vs-name="`terminal_${indexPrincipal}`" vs-value="N">NO</vs-radio>
                  </div>                                                      
                  <div v-if="prodTarj.terminal === 'S'" class="vx-col w-full">
                    <vs-input class="w-full" vs-name="modeloTerminal" v-model="prodTarj.modeloTerminal" 
                      @input="v => { prodTarj.modeloTerminal = v.toUpperCase()}" />            
                  </div>
                </div>
                <div class="vx-row mb-4 mt-4">
                  <div class="vx-col sm:w-1/3 w-full">
                    Prepago
                  </div>
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.prepago" :vs-name="`prepago_${indexPrincipal}`" vs-value="S">SI</vs-radio>
                  </div>
                  <div class="vx-col sm:w-1/6 w-full">
                    <vs-radio v-model="prodTarj.prepago" :vs-name="`prepago_${indexPrincipal}`" vs-value="N">NO</vs-radio>
                  </div> 
                </div>  
                <div v-if="prodTarj.prepago === 'S'" class="vx-row mb-4">                        
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">ICC *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="ICC" :name="`iccc_${prodTarj.id}`" v-validate="{required: true}" v-model="prodTarj.iccc" 
                        @input="v => { prodTarj.iccc = v.toUpperCase()}" /> 
                      <span class="text-danger text-sm"  v-show="errors.has(`iccc_${prodTarj.id}`)">{{ errors.first(`iccc_${prodTarj.id}`) }}</span>           
                    </div>
                  </div>
                </div>              
              </div>   
              <vs-divider />               
              <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full">
                  ¿El titular del móvil es el mismo que el cliente?
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualClientenMovil_${indexPrincipal}`" vs-value="S">SI</vs-radio>
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualClienteMovil_${indexPrincipal}`" vs-value="N">NO</vs-radio>
                </div>              
              </div>          
              <div v-if="prodTarj.titularIgualCliente === 'N'">
                <div class="vx-row mb-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">DNI/CIF *</span>
                    </div>
                    <div>
                      <vx-input-group>
                        <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniTitular" v-model="prodTarj.persona.dni"
                          @input="v => { prodTarj.persona.dni = v.toUpperCase()}"/>
                        <template slot="append">
                          <div class="append-text btn-addon">
                            <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona(prodTarj.persona, index, indexPrincipal)" />
                          </div>
                        </template>
                      </vx-input-group>
                      <span class="text-danger text-sm"  v-show="errors.has('dniTitular')">{{ errors.first('dniTitular') }}</span>
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">Nombre o razón social *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="NOMBRE" name="nombreTitular" v-validate="{required: true}" v-model="prodTarj.persona.nombre"
                        :disabled="titularDisabled" @input="v => { prodTarj.persona.nombre = v.toUpperCase()}"/>
                      <span class="text-danger text-sm"  v-show="errors.has('nombreTitular')">{{ errors.first('nombreTitular') }}</span>           
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span>Apellidos</span>
                    </div>
                    <div>
                      <vs-input class="w-full" name="apellidos" v-model="prodTarj.persona.apellidos"
                        :disabled="titularDisabled" @input="v => { prodTarj.persona.apellidos = v.toUpperCase()}"/>
                    </div>
                  </div>
                </div>
              </div>
              <vs-divider />
              <div class="vx-row mb-2">            
                <div class="vx-col w-full">
                  <vs-collapse>
                    <vs-collapse-item>
                      <div slot="header">
                        Comentario
                      </div>
                      <div class="vx-col w-full">
                        <vs-textarea v-model="prodTarj.comentarios" @input="v => { prodTarj.comentarios = v.toUpperCase()}"/>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </div> 
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" :disabled="habilitarGuardarMovil(prodTarj)" @click="guardarProducto(prodTarj)">Guardar</vs-button>            
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
                  </div>
                </div>
              </div>

            </div>

        </vx-card>
      
      </div>
      <div v-else>

        <!-- vxCard MOVIL -->
        
        <vx-card v-if="item.tipoTarjeta==='MOVIL'" card-border class="mb-4">          
          <vs-row>
            <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
              <span class="textoOperacionComentarioDateTime"><feather-icon icon="SmartphoneIcon" class="mr-2 icon" />{{mostrarSeccion(item.seccion)}}</span>
            </vs-col>
          </vs-row>
          <div v-for="(prodTarj, index) in item.productoTarjetas" :key="index" >
            
            <div class="vx-row mb-4 mt-4">
              <div class="vx-col sm:w-1/2 w-full">
                <div>
                  <span>Estado</span>
                </div>
                <div>
                  <select-val-estado v-model="prodTarj.estado" :categoria="prodTarj.tarjeta" :estadoSelected="prodTarj.estado"/>
                </div>
              </div>
            </div>
            <vs-divider />
            <div class="vx-row mb-4 mt-4">
              <div class="vx-col sm:w-1/3 w-full">
                Móvil
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`movilAlta_${indexPrincipal}`" vs-value="alta">ALTA</vs-radio>
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-radio v-model="prodTarj.altaPortabilidad" :vs-name="`movilAlta_${indexPrincipal}`" vs-value="portabilidad">PORTABILIDAD</vs-radio>
              </div>    
            </div>
            <div v-if="prodTarj.altaPortabilidad == 'portabilidad'">
              <div class="vx-row mb-4">         
                <div class="vx-col sm:w-1/3 w-full">
                  <div>
                    <span>Fecha de portabilidad</span>
                  </div>
                  <div>
                    <flat-pickr data-vv-as="PORTABILIDAD" :name="`fechaPortabilidad_${indexPrincipal}`" :config="configdateTimePicker" v-model="prodTarj.fechaPortabilidad" />
                  </div>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <div>
                    <span class="campoObligatorio">Teléfono portabilidad *</span>
                  </div>
                  <div>
                    <vs-input class="w-full" data-vv-as="TELÉFONO PORTABILIDAD" :name="`telefonoPortabilidad_${prodTarj.id}`" v-validate="{required: true, regex: /^\+?([0-9]+)$/, min: 9 }" v-model="prodTarj.telefonoPortabilidad" 
                      @input="v => { prodTarj.telefonoPortabilidad = v.toUpperCase()}" />
                    <span class="text-danger text-sm"  v-show="errors.has(`telefonoPortabilidad_${prodTarj.id}`)">{{ errors.first(`telefonoPortabilidad_${prodTarj.id}`) }}</span>            
                  </div>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <div>
                    <span class="campoObligatorio">Operador donante *</span>
                  </div>
                  <div>
                    <vs-input class="w-full" data-vv-as="OPERADOR DONANTE" :name="`operadorDonante_${prodTarj.id}`" v-validate="{required: true}" v-model="prodTarj.operadorDonante" 
                        @input="v => { prodTarj.operadorDonante = v.toUpperCase()}" />
                    <span class="text-danger text-sm"  v-show="errors.has(`operadorDonante_${prodTarj.id}`)">{{ errors.first(`operadorDonante_${prodTarj.id}`) }}</span> 
                  </div>
                </div>
              </div>            
              <div class="vx-row mb-4 mt-4">
                <div class="vx-col sm:w-1/3 w-full">                 
                    Terminal y precio
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.terminal" :vs-name="`terminal_${indexPrincipal}`" vs-value="S">SI</vs-radio>
                </div>              
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.terminal" :vs-name="`terminal_${indexPrincipal}`" vs-value="N">NO</vs-radio>
                </div>                                                      
                <div v-if="prodTarj.terminal === 'S'" class="vx-col w-full">
                  <vs-input class="w-full" vs-name="modeloTerminal" v-model="prodTarj.modeloTerminal" 
                    @input="v => { prodTarj.modeloTerminal = v.toUpperCase()}" />            
                </div>
              </div>
              <div class="vx-row mb-4 mt-4">
                <div class="vx-col sm:w-1/3 w-full">
                  Prepago
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.prepago" :vs-name="`prepago_${indexPrincipal}`" vs-value="S">SI</vs-radio>
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-radio v-model="prodTarj.prepago" :vs-name="`prepago_${indexPrincipal}`" vs-value="N">NO</vs-radio>
                </div> 
              </div>  
              <div v-if="prodTarj.prepago === 'S'" class="vx-row mb-4">                        
                <div class="vx-col sm:w-1/2 w-full">
                    <div>
                      <span class="campoObligatorio">ICC *</span>
                    </div>
                    <div>
                      <vs-input class="w-full" data-vv-as="ICC" :name="`iccc_${prodTarj.id}`" v-validate="{required: true}" v-model="prodTarj.iccc" 
                        @input="v => { prodTarj.iccc = v.toUpperCase()}" /> 
                      <span class="text-danger text-sm"  v-show="errors.has(`iccc_${prodTarj.id}`)">{{ errors.first(`iccc_${prodTarj.id}`) }}</span>           
                    </div>
                  </div>
              </div>              
            </div>   
            <vs-divider />               
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                ¿El titular del móvil es el mismo que el cliente?
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualClientenMovil_${indexPrincipal}`" vs-value="S">SI</vs-radio>
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-radio v-model="prodTarj.titularIgualCliente" :vs-name="`titularIgualClienteMovil_${indexPrincipal}`" vs-value="N">NO</vs-radio>
              </div>              
            </div>          
            <div v-if="prodTarj.titularIgualCliente === 'N'">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span class="campoObligatorio">DNI/CIF *</span>
                  </div>
                  <div>
                    <vx-input-group>
                      <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniTitular" v-model="prodTarj.persona.dni"
                        @input="v => { prodTarj.persona.dni = v.toUpperCase()}"/>
                      <template slot="append">
                        <div class="append-text btn-addon">
                          <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona(prodTarj.persona, index, indexPrincipal)" />
                        </div>
                      </template>
                    </vx-input-group>
                    <span class="text-danger text-sm"  v-show="errors.has('dniTitular')">{{ errors.first('dniTitular') }}</span>
                  </div>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span class="campoObligatorio">Nombre o razón social *</span>
                  </div>
                  <div>
                    <vs-input class="w-full" data-vv-as="NOMBRE" name="nombreTitular" v-validate="{required: true}" v-model="prodTarj.persona.nombre"
                      :disabled="titularDisabled" @input="v => { prodTarj.persona.nombre = v.toUpperCase()}"/>
                    <span class="text-danger text-sm"  v-show="errors.has('nombreTitular')">{{ errors.first('nombreTitular') }}</span>
                  </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <div>
                    <span>Apellidos</span>
                  </div>
                  <div>
                    <vs-input class="w-full" name="apellidos" v-model="prodTarj.persona.apellidos"
                      :disabled="titularDisabled" @input="v => { prodTarj.persona.apellidos = v.toUpperCase()}"/>
                  </div>
                </div>
              </div>
            </div>
            <vs-divider />
            <div class="vx-row mb-2">            
              <div class="vx-col w-full">
                <vs-collapse>
                  <vs-collapse-item>
                    <div slot="header">
                      Comentario
                    </div>
                    <div class="vx-col w-full">
                      <vs-textarea v-model="prodTarj.comentarios" @input="v => { prodTarj.comentarios = v.toUpperCase()}"/>
                    </div>
                  </vs-collapse-item>
                </vs-collapse>
              </div>
            </div> 
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <vs-button class="ml-auto mt-2" :disabled="habilitarGuardarMovil(prodTarj)" @click="guardarProducto(prodTarj)">Guardar</vs-button>            
                  <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
                </div>
              </div>
            </div>

          </div>
        </vx-card>
      </div>
      <!-- vxCard TV -->

      <vx-card v-if="item.tipoTarjeta==='TV'" card-border class="mb-4">
        <div v-for="(prodTarj, index) in item.productoTarjetas" :key="index" >
        <vs-row>
          <vs-col class="mb-8" vs-type="flex" vs-align="center" vs-w="12">
            <span class="textoOperacionComentarioDateTime"><feather-icon icon="TvIcon" class="mr-2 icon" />TV</span>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>
          </vs-col>
        </vs-row>
        <div class="vx-row mb-2 mt-2">            
          <div class="vx-col w-full">
            <vs-collapse>
              <vs-collapse-item>
                <div slot="header">
                  Comentario
                </div>
                <div class="vx-col w-full">
                  <vs-textarea v-model="prodTarj.comentarios" @input="v => { prodTarj.comentarios = v.toUpperCase()}"/>
                </div>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <vs-button class="ml-auto mt-2" @click="guardarProducto(prodTarj)">Guardar</vs-button>            
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
            </div>
          </div>
        </div>
        </div>
      </vx-card>      

    </div> <!-- end v-for -->

    <popup-buscar-persona :popupProps="popupProps" @aceptar="popupBuscarPersonaAction" ref="consultarDni" />

    <!-- vxCard SVA -->

      <vx-card v-if="sva.length > 0" card-border class="mb-4">
        <vs-row>
          <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
            <span class="textoOperacionComentarioDateTime"><feather-icon icon="WifiIcon" class="mr-2 icon" />Servicios de valor añadido</span>
          </vs-col>
        </vs-row>
        <div class="vx-row mb-2 mt-2">            
          <div class="vx-col w-full">
            <vs-list>            
              <vs-list-item v-for="(item, index) in sva" :key="index" :title="item"></vs-list-item>            
            </vs-list> 
          </div>
        </div>
      </vx-card>

  </div>  
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'
import productosStore from '@/store/gestion/productos/index.js'
import popupBuscarPersona from '@/views/common-components/popupBuscarPersona'
import personasStore from '@/store/gestion/personas/index.js'

import selectValEstado from '@/views/common-components/selectValEstado'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

export default {
  name: 'OperacionesEditProductosDetalle',
  components: {    
    flatPickr,
    SpanishLocale,
    selectValEstado,
    popupBuscarPersona
  },
  props: {

  },
  data () {
    return {
      productosContratados: {},
      productos: [],
      operacion: {},
      titularId: null,
      movilPrincipal: {},
      titularDisabled: true,
      sva:[],

      //Flat Date Picker
      configdateTimePicker: {
        locale: SpanishLocale,
        altInput: true,  // para que mostre ao usuario a data nun formato e devolva ao servidor un formato distinto (altFormat)
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        mode: 'single',
        defaultDate: null,
        wrap: true
      },
      // popupBuscarPersona
      popupProps: {
        idProducto: '',
        activo: false,
        dni: null,
        relacion: ''  // Relación da persoa coa operación: TITULAR
      }
    }
  },
  methods: {
    habilitarGuardarFijo (prodTarj) {
      let deshabilitar = true
      if (this.errors.any()) {
        return deshabilitar
      }
      if (prodTarj.altaPortabilidad === 'portabilidad') {
        if (prodTarj.telefonoPortabilidad !== undefined && prodTarj.operadorDonante !== undefined) {
          deshabilitar = false
        }        
      } 
      if (prodTarj.titularIgualCliente === 'N') {    
        if (prodTarj.persona.dni !== '' && prodTarj.persona.nombre !== null) { // nombre se pone a null por el popup
          deshabilitar = false
        }
      } 
      if (prodTarj.altaPortabilidad !== 'portabilidad') {
        deshabilitar = false
      }

      return deshabilitar     
    },
    habilitarGuardarMovil (prodTarj) {
      let deshabilitar = true
      let flag = false
      if (this.errors.any()) {
        return deshabilitar
      }
      if (prodTarj.altaPortabilidad === 'portabilidad') {
        if (prodTarj.telefonoPortabilidad !== undefined && prodTarj.operadorDonante !== undefined) { 
          deshabilitar = false
          flag = true
        }
      }
      if (prodTarj.prepago === 'S') {
        deshabilitar = true               
        if (prodTarj.iccc !== undefined) {
          deshabilitar = true          
          if (flag && deshabilitar) {
            deshabilitar = false
          } else {
            deshabilitar = true
          }              
        }      
      } 
      if (prodTarj.titularIgualCliente === 'N') {
        deshabilitar = true
        if (prodTarj.persona.dni !== '' && prodTarj.persona.nombre !== null) {
          deshabilitar = false
        }
      }      
      if (prodTarj.altaPortabilidad !== 'portabilidad') {
        deshabilitar = false
      }
      return deshabilitar
    },
    mostrarSeccion (seccion) {
      return seccion.replace(/#|_/g, ' ')
    },
    async guardarProducto (productoTarjeta) {
      this.$vs.loading('material')

      if (this.titularId === null) {
        const t     = {}
        t.dni       = productoTarjeta.persona.dni
        t.nombre    = productoTarjeta.persona.nombre
        t.apellidos = productoTarjeta.persona.apellidos
        
        await this.$store.dispatch('personasStore/addPersona', t)
          .then((response)   => {
            this.titularId = response.data.id  
            productoTarjeta.persona.dni       = response.data.dni
            productoTarjeta.persona.nombre    = response.data.nombre
            productoTarjeta.persona.apellidos = response.data.apellidos
            productoTarjeta.persona = `/api/personas/${response.data.id}` 
          })
        
          .catch((error) => {
            this.showUpdateError(error)
            console.error(error)
            return true
          })
      } else if (productoTarjeta.titularIgualCliente === 'S') {        
        productoTarjeta.persona  = `/api/personas/${this.cliente.persona.id}` 
      } else {
        productoTarjeta.persona = `/api/personas/${productoTarjeta.persona.id}` 
      }  
      
      typeof productoTarjeta.estado === 'object' ? productoTarjeta.estado = `/api/val_estados/${productoTarjeta.estado.id}` : productoTarjeta.estado = productoTarjeta.estado   
       
      // Vaciamos los datos si pulsamos en los distintos inputs/radio
      if (productoTarjeta.altaPortabilidad !== 'portabilidad') {
        productoTarjeta.fechaPortabilidad = productoTarjeta.telefonoPortabilidad  = productoTarjeta.operadorDonante = null
      }

      if (productoTarjeta.altaPortabilidad === 'alta') {
        productoTarjeta.fechaPortabilidad = productoTarjeta.telefonoPortabilidad  = productoTarjeta.operadorDonante = productoTarjeta.modeloTerminal = productoTarjeta.iccc = null
        productoTarjeta.terminal = productoTarjeta.prepago = 'N'
      }

      if (productoTarjeta.terminal === 'N') {
        productoTarjeta.modeloTerminal = null
      }

      if (productoTarjeta.prepago === 'N') {
        productoTarjeta.iccc = null
      }

      productoTarjeta.completo = true
      
      await this.$store.dispatch('productosStore/updateProductoTarjetas', productoTarjeta)
        .then((response)   => {
          this.showUpdateSuccess('MODIFICACIÓN CORRECTA', 'Guardados datos del producto')          
        })
        .catch((error) => {
          this.showUpdateError(error)
        })

      this.$vs.loading.close()
      
      /**
       * Cando gardamos o detalle dun producto debemos lanzar a función que actualiza a porcentaxe completada da operación
       */
      await this.$store.dispatch('operacionesStore/actualizarPorcentajeCompletado', this.operacion.id)
        .then()
        .catch((error) => {
          console.error(error)         
        })

      await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)
        .then(() => {          
          this.productosContratados = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.productos))     
          // Actualizamos a operación no Store e lanzamos o emit para que se actualice a barra de progreso de porcentaxe completado da operación      
          this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
          this.$emit('actualizar-barra-porcentaje-completado')       
        })
        .catch((error) => {
          this.showUpdateError(error)            
        }) 
      
    },    
    showUpdateSuccess (titulo, texto) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showUpdateError () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'Error',
        text: 'Los datos no han podido ser modificados.'
      })
    },
    reset_data () {
      this.$router.push({name: 'operaciones'})
    },
    abrirPopupBuscarPersona (persona, index, indexPrincipal) {           
      if (!this.errors.has('dniTitular') && persona.dni !== null && persona.dni !== undefined) {        
        this.popupProps.dni = persona.dni
        this.popupProps.index = index
        this.popupProps.indexPrincipal = indexPrincipal
        this.popupProps.idProducto = persona.id
        this.titularId = null // Reseteamos o valor por si tiña asignado un id e se volve chamar ao popup
        // Borramos os datos dos campos por se se chama ao popup máis dunha vez e non se quede algún campo co valor anterior
        this.borrarCamposTitular(persona)
        // Chamamos ao método do popup
        this.$refs.consultarDni.consultarDni()
      }
    },
    popupBuscarPersonaAction (persona) {                  
      this.popupProps.activo = false  // Pechamos o popup      
      if (persona.existe) {
        this.titularId = persona.personaId // Asignamos o id da persoa atopada para gardar na operación        
        this.titularDisabled = false

        this.productosContratados[persona.indexPrincipal].productoTarjetas[persona.index].persona.nombre     = persona.nombre
        this.productosContratados[persona.indexPrincipal].productoTarjetas[persona.index].persona.apellidos  = persona.apellidos
        this.productosContratados[persona.indexPrincipal].productoTarjetas[persona.index].persona.id         = this.titularId
        
        this.titularDisabled = true
      } else {
        this.titularDisabled = false
      }
    },
    borrarCamposTitular (persona) {
      // Habilitamos os campos
      this.titularDisabled = false
      // Borramos os campos
      this.titularId = null
      persona.nombre = null
      //this.titular.dni = null
      persona.apellidos = null
      // Deshabilitamos os campos
      this.titularDisabled = true
    }
  },
  created () {       
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    
    if (!productosStore.isRegistered) {
      this.$store.registerModule('productosStore', productosStore)
      productosStore.isRegistered = true
    }

    if (!personasStore.isRegistered) {
      this.$store.registerModule('personasStore', personasStore)
      personasStore.isRegistered = true
    }

    this.cliente = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'CLIENTE')))
    this.titularId = this.cliente.personaId
    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))    
    this.operacion.productos.length > 0 ? this.productosContratados = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.productos)) : this.productosContratados = []
    this.sva = this.productosContratados.filter((producto) => {  return producto.tipoProducto === 'SVA' }).map((producto) => { return producto.producto })      
  }
}
</script>

